import React from "react";
import { getSpacing } from "../../../designTokens";
import { CenteredPageLoader } from "./CenteredPageLoader";

export interface TableLoadingRowProps {
  colSpan: number;
  message: string;
  cellId: string;
  loaderId?: string;
}

/** Full-width table row with centered spinner + message (for list/table initial loads). */
export const TableLoadingRow: React.FC<TableLoadingRowProps> = ({
  colSpan,
  message,
  cellId,
  loaderId,
}) => (
  <tr>
    <td colSpan={colSpan} id={cellId} style={{ padding: 0, border: "none" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "min(400px, 60vh)",
          width: "100%",
          boxSizing: "border-box",
          padding: `${getSpacing("24px")} ${getSpacing("16px")}`,
        }}
      >
        <CenteredPageLoader
          message={message}
          id={loaderId ?? `${cellId}-loader`}
        />
      </div>
    </td>
  </tr>
);
